<template>
  <div class="bg-gray-100 rounded-lg p-3 d-flex flex-column">
    <a id="mk-list"
       v-for="(item, i) in items"
       target="_blank"
       :href="item.url"
       :key="i"
       :class="$style.item"
       class="d-flex border-bottom border-light py-3">
      <div :class="$style.image" class="rounded-lg overflow-hidden mr-3">
        <Pic :image="item.image"/>
      </div>
      <div>
        <div class="font-size-3 text-primary font-weight-bold">{{ item.title }}</div>
        <div class="text-body">{{ item.description }}</div>
      </div>
    </a>

    <div class="mt-3">
      <Button id="mk-list-button" 
              v-for="(button, i) in buttons" :key="i"
              :label="button.label"
              :url="button.url"
              :message="button.message"/>
    </div>
  </div>
</template>

<script>
  import Button from 'components/Button';
  import Pic from 'components/Pic';

  export default {
    name: 'List',
    components: {Button, Pic},
    props: {
      items: {
        type: Array,
        required: true,
        validator(value) {
          if (!value) return false;
          return value.every(item => item.image && item.title && item.description && item.url);
        }
      },
      buttons: {
        type: Array,
        required: false,
        default() {
          return []
        },
        validator(value) {
          if (!value) return true;
          return value.every(button => button.label && button.url);
        }
      }
    }
  }
</script>

<style lang="scss" module>
  .item {
    &:first-of-type {
      padding-top: 0 !important;
    }

    &:last-of-type {
      padding-bottom: 0 !important;
      border-bottom: none !important;
    }
  }

  .image {
    min-width: 100px;
    width: 100px;
    min-height: 100px;
    height: 100px;
  }
</style>
